import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Processes the OAuth session_id from the URL fragment silently, then lands on /admin.
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    const exchange = async () => {
      try {
        const { data } = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        navigate("/admin", { state: { user: data }, replace: true });
      } catch (e) {
        navigate("/admin/login", {
          state: { error: e.response?.status === 403 ? "owner-only" : "failed" },
          replace: true,
        });
      }
    };
    exchange();
  }, [location, navigate]);

  return null;
}
